<div class="logged-in-view h-full overflow-y-auto">
    <div class="w-full flex items-center mb-8 gap-4">
        <h1 class="text-app-primary-10">Termindetails</h1>
    </div>

    @if (isLoading) {
        <div class="flex items-center justify-center p-20">
            <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-app-primary-10"></div>
        </div>
    } @else if (appointment) {
        <div class="max-w-2xl">
            <div class="border border-app-primary-10 bg-white p-8 rounded-button shadow-sm flex flex-col gap-8">
                <!-- Header Info -->
                <div class="flex justify-between items-start border-b border-app-primary-10/10 pb-6">
                    <div class="flex flex-col gap-1">
                        <span class="text-2xl font-bold text-app-primary-10">
                            {{ appointment.from | date: 'dd. MMMM yyyy' }}
                        </span>
                        <span class="text-lg text-app-primary-10/70">
                            {{ appointment.from | date: 'HH:mm' }} - {{ appointment.to | date: 'HH:mm' }} Uhr
                        </span>
                    </div>
                    <div class="px-4 py-2 rounded-full text-sm font-bold"
                         [ngClass]="isPast ? 'bg-gray-100 text-gray-500' : (appointment.confirmedByPatient ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700')">
                        {{ isPast ? 'Vergangen' : (appointment.confirmedByPatient ? 'Bestätigt' : 'Ausstehend') }}
                    </div>
                </div>

                <!-- Doctor Info -->
                <div class="flex flex-col gap-4">
                    <span class="text-xs font-bold text-app-primary-10/50 uppercase tracking-wider">Behandelnder Arzt</span>
                    <div class="flex items-center gap-4">
                        <div class="flex flex-col">
                            <span class="text-xl font-bold text-app-primary-10">
                                {{ appointment.doctor.title }} {{ appointment.doctor.firstName }} {{ appointment.doctor.lastName }}
                            </span>
<!--                            <span class="text-app-primary-10/60">{{ appointment.doctor.specialization }}</span>-->
                        </div>
                    </div>
                </div>

                <!-- Location / Address -->
                <div class="flex flex-col gap-4">
                    <span class="text-xs font-bold text-app-primary-10/50 uppercase tracking-wider">Praxisanschrift</span>
                    <div class="flex items-start gap-4">
                        <div class="flex flex-col text-app-primary-10">
                            <span class="font-bold">{{ appointment.pharmacy!.name }}</span>
                            <span>{{ appointment.pharmacy!.address.street }} {{ appointment.pharmacy!.address.houseNumber }}</span>
                            <span>{{ appointment.pharmacy!.address.zipCode }} {{ appointment.pharmacy!.address.city }}</span>
                        </div>
                    </div>
                </div>

                <!-- Actions -->
                <div class="mt-4 pt-8 border-t border-app-primary-10/10 flex justify-end gap-4">
                    @if (!isPast) {
                        <button class="btn tertiary-button !text-red-600 hover:!bg-red-50" (click)="cancelAppointment()">
                            Termin absagen
                        </button>
                    }
                </div>
            </div>
        </div>
    } @else {
        <div class="p-20 text-center">
            <h2 class="text-xl font-bold text-app-primary-10">Termin konnte nicht geladen werden</h2>
            <button class="btn primary-button mt-4" routerLink="/termine">Zurück zur Übersicht</button>
        </div>
    }
</div>
